import React, { useState } from "react";

const WHATSAPP_NUMBER = "919873385555"; // +91 9873385555
const WHATSAPP_MESSAGE = "Hi! I have a query about IndiaCloud hosting plans. Can you help me?";

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);

  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: "fixed",
        bottom: "24px",
        right: "24px",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        gap: "10px",
        textDecoration: "none",
        transition: "transform 0.2s ease",
        transform: hovered ? "scale(1.08)" : "scale(1)",
      }}
    >
      {/* Tooltip label */}
      <span
        style={{
          opacity: hovered ? 1 : 0,
          transform: hovered ? "translateX(0)" : "translateX(8px)",
          transition: "opacity 0.2s ease, transform 0.2s ease",
          background: "rgba(10,10,18,0.95)",
          border: "1px solid rgba(37,211,102,0.3)",
          color: "#fff",
          fontSize: "13px",
          fontFamily: "'Outfit', sans-serif",
          fontWeight: 500,
          padding: "8px 14px",
          borderRadius: "12px",
          whiteSpace: "nowrap",
          boxShadow: "0 4px 20px rgba(37,211,102,0.15)",
          pointerEvents: "none",
        }}
      >
        💬 Chat with us on WhatsApp
      </span>

      {/* WhatsApp button */}
      <div
        style={{
          width: "56px",
          height: "56px",
          borderRadius: "50%",
          background: "linear-gradient(135deg, #25D366, #128C7E)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: hovered
            ? "0 0 0 6px rgba(37,211,102,0.2), 0 8px 32px rgba(37,211,102,0.45)"
            : "0 0 0 0px rgba(37,211,102,0), 0 4px 20px rgba(37,211,102,0.35)",
          transition: "box-shadow 0.3s ease",
          flexShrink: 0,
        }}
      >
        {/* WhatsApp SVG icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          width="30"
          height="30"
          fill="#fff"
        >
          <path d="M16 0C7.163 0 0 7.163 0 16c0 2.822.736 5.469 2.027 7.773L0 32l8.469-2.001A15.936 15.936 0 0016 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.27 13.27 0 01-6.771-1.849l-.485-.288-5.027 1.187 1.237-4.896-.317-.502A13.267 13.267 0 012.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.274-9.931c-.399-.199-2.36-1.164-2.727-1.297-.366-.133-.632-.199-.898.2-.266.398-1.031 1.297-1.264 1.563-.233.266-.465.299-.864.1-.399-.2-1.684-.621-3.208-1.98-1.186-1.057-1.988-2.363-2.221-2.762-.234-.399-.025-.614.175-.813.18-.179.399-.465.598-.698.199-.233.266-.399.399-.665.133-.266.066-.499-.033-.698-.1-.199-.898-2.163-1.231-2.961-.324-.779-.654-.674-.898-.686l-.765-.013c-.266 0-.698.1-1.064.499-.366.399-1.397 1.365-1.397 3.328s1.431 3.861 1.63 4.127c.199.266 2.816 4.3 6.82 6.03.953.411 1.696.657 2.275.841.956.305 1.826.262 2.514.159.767-.114 2.36-.965 2.693-1.897.333-.933.333-1.731.233-1.897-.099-.166-.365-.266-.764-.465z" />
        </svg>
      </div>

      {/* Pulse ring animation */}
      <style>{`
        @keyframes wa-pulse {
          0% { transform: scale(1); opacity: 0.6; }
          100% { transform: scale(1.7); opacity: 0; }
        }
        .wa-pulse-ring {
          position: absolute;
          bottom: 24px;
          right: 24px;
          width: 56px;
          height: 56px;
          border-radius: 50%;
          background: rgba(37,211,102,0.35);
          animation: wa-pulse 2s ease-out infinite;
          z-index: 9998;
          pointer-events: none;
        }
      `}</style>
    </a>
  );
}
